import { Auth } from 'aws-amplify';
import { 
  CognitoUser, 
  CognitoUserPool,
  CognitoUserSession,
  CognitoAccessToken,
  CognitoIdToken,
  CognitoRefreshToken
} from 'amazon-cognito-identity-js';

/**
 * Set AWS Amplify session from backend tokens
 * @param {Object} tokens - { AccessToken, IdToken, RefreshToken }
 */
export async function setAmplifySessionFromTokens(tokens) {
  try {
    const { AccessToken, IdToken, RefreshToken } = tokens;
    
    if (!AccessToken || !IdToken || !RefreshToken) {
      throw new Error('Missing required tokens');
    }
    
    // Get user pool config from Amplify
    const config = Auth.configure();
    if (!config.userPoolId || !config.userPoolWebClientId) {
      throw new Error('Amplify not configured properly');
    }
    
    const userPool = new CognitoUserPool({
      UserPoolId: config.userPoolId,
      ClientId: config.userPoolWebClientId
    });
    
    // Decode IdToken to get username
    const idTokenPayload = JSON.parse(atob(IdToken.split('.')[1]));
    const username = idTokenPayload['cognito:username'] || idTokenPayload.sub;
    
    // Create CognitoUser
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: userPool
    });
    
    // Create token objects
    const accessToken = new CognitoAccessToken({ AccessToken });
    const idToken = new CognitoIdToken({ IdToken });
    const refreshToken = new CognitoRefreshToken({ RefreshToken });
    
    // Create session
    const session = new CognitoUserSession({
      IdToken: idToken,
      AccessToken: accessToken,
      RefreshToken: refreshToken
    });
    
    // Set session to user
    cognitoUser.setSignInUserSession(session);
    
    // Store user in Amplify cache
    try {
      await Auth.currentAuthenticatedUser();
    } catch (e) {
      // Could not cache user in Amplify - non-critical error
      // Continue as session is already set on cognitoUser
    }
    
    return cognitoUser;
  } catch (error) {
    // Re-throw error to be handled by caller
    throw error;
  }
}
